const educationLevels = [
  "Graduate Degree or Higher",
  "College Graduate",
  "Some College or Associate’s Degree",
  "High School Graduate",
  "Not a High School Graduate",
  "Decline to State",
];

export default educationLevels;
